const URLS = {
    partnersCatalogue: '/partners/catalogue',
    partnerDetail: '/partners/catalogue',
    partnerProductDetail: '/partners/catalogue/product',
};

const Dashboard = {
    Compute: 'compute',
    K8S: 'managed-kubernetes',
    Datalens: 'datalens',
};

const DashboardTabValues = [
    {
        name: 'software',
        type: 'compute-and-k8s',
        dashboardTypes: [Dashboard.Compute, Dashboard.K8S],
    },
    {
        name: 'datalens',
        type: 'datalens',
        dashboardTypes: [Dashboard.Datalens],
    },
];

const DashboardTabs = DashboardTabValues.reduce((acc, dashboardTab) => {
    acc[dashboardTab.name] = dashboardTab.type;
    return acc;
}, {});

const Sorting = {
    Default: 'default',
    Popularity: 'popularity',
    Alphabetical: 'name-a-z',
    Newest: 'newest',
};

const HEADER_PRODUCTS_COUNT = 7;

module.exports = {
    URLS,
    HEADER_PRODUCTS_COUNT,
    Dashboard,
    DashboardTabs,
    DashboardTabValues,
    Sorting,
};
